import { useUserConfig, withMeetingNoteSourceEnabled } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { XStack, YStack } from '@/components/ui/layout/layout';
import { Switch } from '@/components/ui/Switch';

import { meetingNoteSourceForProvider } from './meeting-note-source-for-provider';

import type { ConfigurationContext } from './configuration.types';

export const MeetingNotesConfiguration = observer(
  function MeetingNotesConfiguration({
    context,
  }: {
    context: ConfigurationContext;
  }) {
    const userConfig = useUserConfig();
    const source = meetingNoteSourceForProvider(context.provider);
    if (!source) return null;

    const disabledSources =
      userConfig.meetings.get('disabled_note_sources') ?? [];
    const label = `Show ${source.displayName} notes in Meeting Notes`;

    return (
      <YStack className="gap-4 p-6">
        <XStack className="items-center justify-between rounded-lg border border-border p-3">
          <YStack className="gap-0.5">
            <span className="text-sm font-medium text-foreground">{label}</span>
            <span className="text-xs text-foreground-muted">
              Your {source.displayName} meetings appear next to the ones
              Littlebird records
            </span>
          </YStack>
          <Switch
            aria-label={label}
            checked={!disabledSources.includes(source.slug)}
            onCheckedChange={(enabled) =>
              userConfig.meetings.set(
                'disabled_note_sources',
                withMeetingNoteSourceEnabled(
                  disabledSources,
                  source.slug,
                  enabled
                )
              )
            }
          />
        </XStack>
      </YStack>
    );
  }
);
